import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Aurora } from "@/components/Aurora";

export const FunnelCTA = ({ product, article }) => (
  <section className="relative bg-[#0B132B] text-white grain overflow-hidden">
    <Aurora intensity="intense" />
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-32 text-left">
      <p data-reveal className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-4">
        Your next step
      </p>
      <h2
        data-reveal
        className="font-heading font-black text-4xl sm:text-5xl lg:text-7xl tracking-tighter leading-[0.95] max-w-3xl"
      >
        See what {article} {product.tag} looks like <span className="text-gradient-breeze">built around you.</span>
      </h2>
      <p data-reveal className="mt-6 text-base md:text-lg text-white/70 font-light leading-relaxed max-w-xl">
        A licensed broker builds your options from 50+ A-rated carriers, walks you through every line, and answers
        anything we didn't cover here. Free, and zero pressure.
      </p>
      <Link
        to="/products"
        data-reveal
        data-testid="funnel-explore-link"
        className="mt-9 inline-flex items-center gap-1.5 text-sm font-semibold text-white/60 hover:text-[#4CC3F0] transition-colors"
      >
        Not sure {article} {product.tag} is for you? Explore other strategies <ArrowRight size={14} />
      </Link>
    </div>
  </section>
);
